import { isYupArraySchema, yup } from '@framework/validation';
import { FormBuilderMetaFlags } from '../../../../validator';
import { RuleType } from '../../IRule';
import { IRuleType } from '../../IRuleType';
import { RequiredRuleComponent } from './RequiredRuleComponent';

const configValidator = yup
  .object({
    value: yup.boolean().notRequired().label('Campo Richiesto'),
    customMessage: yup
      .string()
      .notRequired()
      .label('Messaggio personalizzato di validazione'),
  })
  .notRequired()
  .nullable()
  .noUnknown();

type IRuleRequiredType = yup.InferType<typeof configValidator>;

export const RequiredRule: IRuleType<IRuleRequiredType> = {
  type: RuleType.Required,
  name: 'Campo Richiesto',
  configComponent: RequiredRuleComponent,
  configValidator: configValidator,
  validator: (schema, rule) => {
    if (!rule?.value) return schema;

    const flags = schema.meta?.() ?? {};

    // Se è attivo il flag "Ignora required", non applico la regola
    if (flags[FormBuilderMetaFlags.IgnoreRequired]) {
      return schema;
    }

    const customMessage = rule.customMessage ? rule.customMessage : undefined;

    // Per gli array, il required equivale a minimo 1 elemento
    if (isYupArraySchema(schema)) {
      return schema.min(1, customMessage).required();
    }

    return schema.required(customMessage);
  },
};
